export default __webpack_public_path__ + "static/media/double-layer.89acb25c.svg";